<template>
  <b-row>
    <b-col cols="12">
      <b-card  class="d-flex" no-body>
        <b-card-header>
          <div>
            <b-card-title class="analytics-title">{{$t('campaigns.contentDistribution') }}</b-card-title>
          </div>
          <b-button variant="outline-secondary" class="cursor-pointer" @click="resetChartZoom">
            <img src="@/assets/images/icons/reset.png" width="20">
          </b-button>
        </b-card-header>

        <b-card-body>
          <component
            id="myChart"
            ref="myChart"
            :is="apex_charts"
            type="scatter"
            height="350"
            :options="chartOptions"
            :series="series"
            :key="change_graph"
            @click="handleClick"
          >
          </component>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
} from "bootstrap-vue";
import { getDatev2 } from '@/libs/utils/times';
import { getIconWhite, getIconColor } from '@/libs/utils/icons'

export default {
  name: "ScatterAnalytics",
  props: {
    contents: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
  },
  data() {
    return {
      getIconWhite,
      getIconColor,
      change_graph: false,
      series: [],
      chartOptions: {
        noData: {
          text: 'No hay datos para mostrar',
          align: 'center',
          verticalAlign: 'middle',
          style: {
            color: '#999',
            fontSize: '14px'
          }
        },
        chart: {
          height: 350,
          type: 'scatter',
          zoom: {
            type: 'x'
          },
          toolbar: {
            show: true,
            tools: {
              download: false,
              selection: false,
              zoom: '<b-icon/>',
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
        },
        dataLabels: {
          enabled: false
        },
        grid: {
          xaxis: {
            lines: {
              show: true
            }
          },
          yaxis: {
            lines: {
              show: true
            }
          },
        },
        xaxis: {
          type: 'datetime',
          min: new Date(`${new Date().getFullYear()}-01-01`).getTime(),
          max: new Date(`${new Date().getFullYear()}-12-31`).getTime(),
        },
        yaxis: {
          max: 70
        },
        tooltip: {
          custom: ({seriesIndex, dataPointIndex, w}) => {
            const dataPoint = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
            const date_instance = new Date(dataPoint[0]);
            date_instance.setDate(date_instance.getDate());

            const content = dataPoint[2];
            const influencer = content.influencer;

            const network = content.network;

            const icon_src = getIconWhite(network);
            const icon_class = getIconColor(network);

            return (
              `<div class="width-tooltip-graph">
                <div class="d-block bg-toottip-graph p-1">
                  ${getDatev2(new Date(date_instance))}
                </div>
                <div class="p-1">
                  <strong class="mr-tooltip-graph">
                    ${w.globals.initialSeries[seriesIndex].name}
                  </strong>
                </div>
                <div class="p-1">
                  <div class="d-flex align-items-center">
                    <img src="${influencer.image_url}"
                      style="width:30px; height:30px; border-radius:50%; padding:2px; object-fit:cover;">
                  </div>
                 
                  <div><strong>Nombre:</strong> ${influencer.name}</div>
                  <div><strong>Username:</strong> ${influencer.username}</div>
                  <div class="d-flex align-items-center">
                    <div><strong class="mr-1">Plataforma: </div>
                    <img src="${icon_src}" class="${icon_class}"
                      style="width:20px; height:20px; border-radius:50%; padding:2px; object-fit:cover;">
                  </div>
                </div>
              </div>`
            );

          }
        },
      },
      apex_charts: null,
    }
  },
  created() {
    window.addEventListener("resize", this.myEventHandler);
    this.formatContents()
  },
  async mounted() {
    this.apex_charts = (await import('vue-apexcharts')).default;
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    resetChartZoom() {
      this.change_graph = !this.change_graph;
    },

    handleClick(event, chartContext, config) {
      if (config.dataPointIndex !== -1) {
        this.clickPointer(config.globals.initialSeries[config.seriesIndex].data[config.dataPointIndex][2])        
      }
    },
    myEventHandler() {
      this.change_graph = !this.change_graph;
    },
    clickPointer(content) {
      const url = this.getUrl(content);
      window.open(url, "_blank");
    },
    getUrl(content) {
      if (content.url_info) return content.url_info
      else return content.image_content
    },
    formatContents() {
      const data = [
        {
          name: this.$t('influencerCategory.top-celebrity'),
          id: 'top-celebrity',
          symbolSize: 10,
          data: [],
          weight: 50,
        },
        {
          name: this.$t('influencerCategory.top-influencer-celebrity'),
          id: 'top-influencer-celebrity',
          symbolSize: 10,
          data: [],
          weight: 40,
        },
        {
          name: this.$t('influencerCategory.macroinfluencer'),
          id: 'macroinfluencer',
          symbolSize: 10,
          data: [],
          weight: 30,
        },
        {
          name: this.$t('influencerCategory.microinfluencer'),
          id: 'microinfluencer',
          symbolSize: 10,
          data: [],
          weight: 20,
        },
        {
          name: this.$t('influencerCategory.nanoinfluencer'),
          id: 'nanoinfluencer',
          symbolSize: 10,
          data: [],
          weight: 10,
        },
      ];

      const contents = [...this.contents].sort((a, b) => {
        return new Date(a.published_date).getTime() - new Date(b.published_date).getTime();
      });

      contents.forEach((content, index) => {
        const has_url = this.checkUrlPublish(content);
        if (has_url) {
          const date_instance = new Date(content.published_date);
          const serie = data.find(item => item.id === content.influencer.calculate_category);
          const x = index * 5;
          if (serie) {
            serie.data.push([date_instance.getTime(), x, content]);
          }
        }
      });

      const dummyDate = new Date(`${new Date().getFullYear()}-01-01`).getTime();
      data.forEach(serie => {
        if (serie.data.length === 0) {
          serie.data.push([dummyDate, null, null]);
        }
      });

      this.series = data;
      this.change_graph = !this.change_graph;
    },
    checkUrlPublish(content) {
      return content.url_info || content.image_content
    }
  },
  watch: {
    "$i18n.locale"() {
      this.formatContents();
    },
  },
};
</script>

<style>
.w-full {
  width: 100%;
}
</style>
